const alertPageTypes = {
  TOGGLE_VISIBILITY: "TOGGLE_VISIBILITY",

  SET_MESSAGE: "SET_MESSAGE",

  SET_FIRST_BTN: "SET_FIRST_BTN",
  SET_SECOND_BTN: "SET_SECOND_BTN",

  SET_FIRST_BTN_FUNC: "SET_FIRST_BTN_FUNC",
  SET_SECOND_BTN_FUNC: "SET_SECOND_BTN_FUNC",

  SET_ALERTPAGE_CLEAN: "SET_ALERTPAGE_CLEAN",
};

export default alertPageTypes;
